import React from "react";
import PropTypes from "prop-types";
import i18n from "../../Helpers/i18n";

const TrafficLights = ({ status }) => {
    const TrafficOptions = [1, 2, 3];
    if (!TrafficOptions.includes(status)) {
        return (
            <span className="traffic-lights__not-available">
                {i18n.t("traffic.notAvailable")}
            </span>
        );
    }

    let trafficLights = [];
    for (let i = 1; i <= status; i++) {
        trafficLights.push(<span key={i} />);
    }

    return (
        <div className={`traffic-lights traffic-lights__${status}`}>
            {trafficLights}
        </div>
    );
};

TrafficLights.propTypes = {
    status: PropTypes.number.isRequired,
};

TrafficLights.defaultProps = {
    status: 0,
};

export default TrafficLights;
